import { createApp } from "vue";
import SustainabilityExplainerDrawer from "@/app/javascript/components/listings/SustainabilityExplainerDrawer.vue";
import I18n from "../plugins/i18n";
import { ready } from "../utils/listeners";

const setupSustainabilityExplainerDrawer = () => {
  const node = document.getElementById("sustainability-explainer-drawer-app");

  if (!node) return;
  const props = JSON.parse(node.dataset.props);

  const translations = JSON.parse(node.dataset.translations);

  const app = createApp(SustainabilityExplainerDrawer, props);

  app.use(I18n, translations);
  app.mount(node);
};

ready(setupSustainabilityExplainerDrawer);
